import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { theme } from 'inpock-ui-react';

const pulse = keyframes`
    0% {
        opacity: 0;
    }

    80% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
`;

export const PageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 260px;
`;

export const LoadingTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
`;

export const LoadingText = styled.p`
  margin-top: 1.6rem;
  font-size: 20px;
  font-weight: 500;
  color: ${() => theme.colors.gray400};
  animation: ${pulse} 1.5s infinite;
`;
